import {ThemeProvider,CssBaseline,Box} from "@mui/material";
import {BrowserRouter,Routes,Route,useLocation,Navigate} from "react-router-dom";
import {useEffect} from "react";

import Navbar from "./components/Navbar";
import Scroll from "./components/Scroll";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Calendar from "./pages/Calendar";
import LiveMatchPage from "./pages/LiveMatchPage";

import Login from "./login/Login";
import UpdatePassword from "./login/UpdatePassword";
import AdminDashboard from "./login/Admin/AdminDashboard";
import DelegateDashboard from "./login/Delegado/DelegateDashboard";
import ProtectedRoute from "./login/ProtectedRoute";

import theme from "./Theme";

function Layout(){
  const location=useLocation();

  const isPrivateRoute=
    location.pathname==="/admin"||
    location.pathname.startsWith("/admin/")||
    location.pathname==="/delegado"||
    location.pathname.startsWith("/delegado/")||
    location.pathname==="/actualizar-clave";

  useEffect(()=>{
    window.scrollTo(0,0);
  },[location.pathname]);

  return(
    <Box
      sx={{
        display:"flex",
        flexDirection:"column",
        minHeight:"100vh",
        backgroundColor:"#FFFFFF"
      }}
    >
      {!isPrivateRoute&&<Navbar/>}

      {!isPrivateRoute&&<Scroll/>}

      <Box
        component="main"
        sx={{
          flex:1,
          minWidth:0
        }}
      >
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/torneos/nexus-cup-2026/calendario" element={<Calendar/>}/>
          <Route path="/calendario-de-partidos" element={<Navigate to="/torneos/nexus-cup-2026/calendario" replace/>}/>
          <Route path="/partido/:slug" element={<LiveMatchPage/>}/>
          <Route path="/admin-login" element={<Login/>}/>
          <Route path="/actualizar-clave" element={<ProtectedRoute allowedRoles={["SUPERADMIN","ADMIN","DELEGADO"]}><UpdatePassword/></ProtectedRoute>}/>
          <Route path="/admin/*" element={<ProtectedRoute allowedRoles={["SUPERADMIN","ADMIN"]}><AdminDashboard/></ProtectedRoute>}/>
          <Route path="/delegado/*" element={<ProtectedRoute allowedRoles={["DELEGADO"]}><DelegateDashboard/></ProtectedRoute>}/>
          <Route path="*" element={<Navigate to="/" replace/>}/>
        </Routes>
      </Box>

      {!isPrivateRoute&&<Footer/>}
    </Box>
  );
}

export default function App(){
  return(
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <BrowserRouter>
        <Layout/>
      </BrowserRouter>
    </ThemeProvider>
  );
}